import { render } from "./OpenIndicator.vue?vue&type=template&id=f60a9bd8"
const script = {}

import "./OpenIndicator.vue?vue&type=style&index=0&id=f60a9bd8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__